const heldKeys = new Set<string>();
let jumpQueued = false;
let jumpReleasedQueued = false;
let powerQueued = false;
let restartQueued = false;
let touchJumpHeld = false;
let touchMoveX = 0;
let tiltMoveX = 0;
let started = false;

export type InputFrame = {
  moveX: number;
  jumpPressed: boolean;
  jumpHeld: boolean;
  jumpReleased: boolean;
  powerPressed: boolean;
  restartPressed: boolean;
};

export function startInputCapture(canvas?: HTMLElement, powerButton?: HTMLElement, leftButton?: HTMLElement, rightButton?: HTMLElement): void {
  if (started) {
    return;
  }

  started = true;

  window.addEventListener('keydown', event => {
    heldKeys.add(event.code);

    if (event.code === 'Space') {
      jumpQueued = true;
      event.preventDefault();
    }

    if (event.code === 'ShiftLeft' || event.code === 'ShiftRight') {
      powerQueued = true;
      event.preventDefault();
    }

    if (event.code === 'Enter' || event.code === 'KeyR') {
      restartQueued = true;
      event.preventDefault();
    }
  });

  window.addEventListener('keyup', event => {
    heldKeys.delete(event.code);
    if (event.code === 'Space') {
      jumpReleasedQueued = true;
      event.preventDefault();
    }
  });

  window.addEventListener('deviceorientation', event => {
    if (typeof event.gamma === 'number') {
      tiltMoveX = clamp(event.gamma / 18, -1, 1);
    }
  });

  canvas?.addEventListener('pointerdown', event => {
    jumpQueued = true;
    touchJumpHeld = true;
    canvas.setPointerCapture(event.pointerId);
    event.preventDefault();
  });

  const releaseJump = (event: PointerEvent): void => {
    if (touchJumpHeld) {
      jumpReleasedQueued = true;
    }
    touchJumpHeld = false;
    if (canvas?.hasPointerCapture(event.pointerId)) {
      canvas.releasePointerCapture(event.pointerId);
    }
    event.preventDefault();
  };

  canvas?.addEventListener('pointerup', releaseJump);
  canvas?.addEventListener('pointercancel', releaseJump);

  powerButton?.addEventListener('pointerdown', event => {
    powerQueued = true;
    event.preventDefault();
  });

  bindHoldButton(leftButton, -1);
  bindHoldButton(rightButton, 1);
}

export function readInputFrame(): InputFrame {
  const keyMoveX = Number(heldKeys.has('ArrowRight') || heldKeys.has('KeyD')) - Number(heldKeys.has('ArrowLeft') || heldKeys.has('KeyA'));
  const moveX = clamp(keyMoveX || touchMoveX || tiltMoveX, -1, 1);
  const frame = {
    moveX,
    jumpPressed: jumpQueued,
    jumpHeld: heldKeys.has('Space') || touchJumpHeld,
    jumpReleased: jumpReleasedQueued,
    powerPressed: powerQueued,
    restartPressed: restartQueued
  };
  jumpQueued = false;
  jumpReleasedQueued = false;
  powerQueued = false;
  restartQueued = false;
  return frame;
}

function bindHoldButton(button: HTMLElement | undefined, direction: -1 | 1): void {
  if (!button) {
    return;
  }

  button.addEventListener('pointerdown', event => {
    touchMoveX = direction;
    button.setPointerCapture(event.pointerId);
    event.preventDefault();
  });

  const release = (event: PointerEvent): void => {
    if (touchMoveX === direction) {
      touchMoveX = 0;
    }
    if (button.hasPointerCapture(event.pointerId)) {
      button.releasePointerCapture(event.pointerId);
    }
    event.preventDefault();
  };

  button.addEventListener('pointerup', release);
  button.addEventListener('pointercancel', release);
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
